import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import Copy from '../Common/Copy';
import { GMCContext } from '../../GMCContext';
import Pagination from '../Common/Pagination';


export default function LevelRewardReport({ username }) {
  const { togel, setTogel, isSidebarEnabled, setIsSidebarEnabled, formatDateTime, formatAddress } = useContext(GMCContext);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pages, setPages] = useState(1);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [level, setlevel] = useState(""); // Default to "All"


  // Fetch data function
  const getData = async () => {
    try {
      setLoading(true);
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "lreward",
        submethod: "getbyid",
        key: process.env.REACT_APP_KEY,
        username,
        search: search,
        page: currentPage,
        pageSize,
        level: level !== "" ? parseInt(level, 10) : undefined, // Pass the selected level

      });
      // console.log('search', search)
      setLoading(false);
      if (res.data.error) return;
      // console.log('res.data.data', res.data.data)
      setData(res.data.data);
      setPages(Math.ceil(res.data.total / pageSize));
    } catch (err) {
      console.log("Error : ", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (username) {
      getData();
    }
  }, [username, pages, pageSize, currentPage]);

  useEffect(() => {
    if (search) {
      setCurrentPage(1);
    }
    getData();
  }, [pageSize, currentPage, search, level]);

  return (
    <>
      {/* Member Report Table Section */}
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title mb-0">Level Report</h4>
            </div>
            <div className="card-body">
              <div className="listjs-table" id="customerList">
                {/* Table Action Buttons */}
                <div className="row g-4 mb-3 align-items-center">
                  {/* Dropdown for selecting levels */}
                  <div className="col-sm-auto">
                    <div className="input-group">
                      <label className="input-group-text" htmlFor="levelSelect">
                        Level
                      </label>
                      <select
                        id="levelSelect"
                        className="form-select"
                        value={level}
                        onChange={(e) => {
                          setlevel(e.target.value);
                          setCurrentPage(1); // Reset to the first page when level changes
                        }}
                      >
                        <option value="">All</option>
                        {[...Array(20)].map((_, i) => (
                          <option key={i + 1} value={i + 1}>
                            {i + 1}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Search box */}
                  <div className="col-sm">
                    <div className="d-flex justify-content-sm-end">
                      <div className="search-box ms-2">
                        <input
                          type="text"
                          className="form-control search"
                          placeholder="Search..."
                          onChange={(e) => setSearch(e.target.value)}
                        />
                        <i className="ri-search-line search-icon" />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Table */}
                <div className="table-responsive table-card mt-3 mb-1">
                  <table className="table align-middle table-nowrap" id="customerTable">
                    <thead className="table-light">
                      <tr>
                        <th className="gridjs-th text-center">#</th>
                        <th className="gridjs-th text-center">From</th>
                        <th className="gridjs-th text-center">Amount</th>
                        <th className="gridjs-th text-center">Level</th>
                        <th className="gridjs-th text-center">Level Reward</th>
                        <th className="gridjs-th text-center">Status</th>
                        <th className="gridjs-th text-center">Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.length > 0 ? (
                        data.map((ele, i) => {
                          const index = currentPage * pageSize - pageSize + (i + 1);
                          return (
                            <tr key={i}>
                              <td className="gridjs-td">
                                <div className="form-check">
                                  <input className="form-check-input row-check" type="checkbox" />
                                  <label className="form-check-label"></label>
                                </div>
                              </td>
                              <td className="gridjs-td text-center">{index}</td>
                              <td className="gridjs-td text-center">
                                <div>
                                  <a
                                    target="_blank"
                                    className="text-primary"
                                    href={`${process.env.REACT_APP_EXPLORER}/address/${ele.username}`}
                                    rel="noreferrer"
                                  >
                                    <span className="name-title">Address:</span> {ele.username}
                                  </a>
                                  <Copy data={ele.username} />
                                </div>
                                <div className="ref-name">
                                  <span className="name-title">Name:</span> {ele.toname || "-"}
                                  <Copy data={ele.toname} />
                                </div>
                              </td>
                              <td className="gridjs-td text-center">$ {ele.amount || "0"}</td>
                              <td className="gridjs-td text-center"> {ele.level || "0"}</td>
                              <td className="gridjs-td text-center">{parseFloat(ele.reward).toFixed(2)} ({(ele.lrewardper || "0")}%)</td>
                              <td className="gridjs-td text-center">
                                <span className={`badge ${ele.flush ? 'bg-success-subtle  text-success' : 'bg-danger-subtle text-danger'} text-uppercase`}>
                                  {ele.flush ? "Complet" : "Flush "}
                                </span>
                              </td>
                              <td className="gridjs-td text-center">{formatDateTime(ele.createdAt)}</td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="11" className="text-center">
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <Pagination
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  pages={pages}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
